import React, { useState, useEffect } from "react";
import HomePage from "../app/page";
import FaqPage from "../app/faq/page";
import ThankYouPage from "../app/start-the-conversation/thank-you/page";
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "../app/globals.css";
import "../app/mobile-foundation.css";

export default function App() {
  const [currentPath, setCurrentPath] = useState(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener("popstate", handleLocationChange);
    return () => window.removeEventListener("popstate", handleLocationChange);
  }, []);

  const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
  const relativePath = base && currentPath.startsWith(base)
    ? currentPath.slice(base.length) || "/"
    : currentPath;

  if (relativePath.includes("/start-the-conversation/thank-you")) {
    return <ThankYouPage />;
  }

  if (relativePath === "/faq" || relativePath === "/faq/" || relativePath.startsWith("/faq")) {
    return <FaqPage />;
  }

  return <HomePage />;
}
